const NOT_SAVED_CONFIG = {
  DRAFT_NOT_SAVED: {}
};
const EMPTY_CONFIG = {};
export const getDraftSaveConfig = ({
  draftSaveFailed
}) => {
  return draftSaveFailed ? NOT_SAVED_CONFIG : EMPTY_CONFIG;
};